import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';

import { createTableApiScopeRequirement } from 'utils/rbac/helpers/createTableApiScopeRequirement';
import { ApiTokens } from './ApiTokens/ApiTokens';
import { McpServer } from './McpServer/McpServer';
import { WebHooks } from './WebHooks/WebHooks';

export const integrationRoutes: RoutesTreeItem[] = [
  {
    path: '/settings/integration/api-tokens',
    requiredApiScope: createTableApiScopeRequirement(
      '/tables/settings/api-tokens',
    ),
    element: <ApiTokens />,
  },
  {
    path: '/settings/integration/webhooks/*',
    requiredApiScope: {
      and: [
        { method: 'GET', path: '/webhooks' },
        { method: 'GET', path: '/webhooks/types' },
      ],
    },
    element: <WebHooks />,
  },
  {
    path: '/settings/integration/mcp-server',
    requiredApiScope: {
      and: [
        { method: 'GET', path: '/settings' },
        { method: 'POST', path: '/settings/mcp-server' },
      ],
    },
    element: <McpServer />,
  },
];
